<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <large-base-card
    class=" d-flex align-start justify-center flex-column"
  >
    <v-skeleton-loader
      v-if="loading"
      height="146"
      type="card"
      width="100%"
    />
    <template v-else>
      <div class="text-overline text--secondary">
        {{ subtitle }}
      </div>
      <div
        :class="color+'--text'"
        class="text-h2 font-weight-bold text-no-wrap text-truncate"
      >
        {{ info }}
      </div>
      <div
        class="text-body-1 mt-1 d-flex"
        style="width: 100%"
      >
        {{ title }}
      </div>
    </template>
  </large-base-card>
</template>

<script>
  import LargeBaseCard from '@/composable/LargeBaseCard'

  export default {
    name: 'DashboardCard',
    components: { LargeBaseCard },
    props: {
      title: {},
      subtitle: {},
      info: {},
      color: {},
      loading: {},
    },
  }
</script>

<style scoped>

</style>
